<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useAbsenceReasonStore} from "@/stores/AbsenceReason";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$i18n, $router} = useTools();

        const {
            loading,
            total,
        } = useSharedData();

        const securityStore = useSecurityStore();
        const absenceReasonStore = useAbsenceReasonStore();

        const search = ref(null);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: false,
                value: "name",
                width: "0%",
            },
            {
                text: $i18n.t("module.balance"),
                align: "start",
                sortable: false,
                value: "balanceName",
                width: "0%",
            },
            {
                text: $i18n.t("absence_reason.unite"),
                align: "start",
                sortable: false,
                value: "unite",
                width: "0%",
            },
            {
                text: $i18n.t("absence_reason.mode"),
                align: "start",
                sortable: false,
                value: "mode",
                width: "0%",
            },
            {
                text: $i18n.t("absence_reason.days_before_name"),
                align: "start",
                sortable: false,
                value: "daysBefore",
                width: "0%",
            },
            {
                text: $i18n.t("absence_reason.include_inpay_name"),
                align: "start",
                sortable: false,
                value: "includedInPay",
                width: "0%",
            },
            {
                text: $i18n.t("common.color"),
                align: "start",
                sortable: false,
                value: "color",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'absence_reasons.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'absence_reasons.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/absenceReasons').then((response) => {
                absenceReasonStore.setAbsenceReasons(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "absence_reasons.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            absenceReasonStore,
            loading,
            total,
            headers,
            actions,
            search,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.absence_reasons')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_ABSENCE_REQUEST_PARAM']"
                    @press="$router.push({ name: 'absence_reasons.add' })"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    :items="absenceReasonStore.absenceReasons"
                    :total="total"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.balanceName`]="{ item }">
                        <w-inline-text :text="item.balanceName"/>
                    </template>
                    <template v-slot:[`item.unite`]="{ item }">
                        <w-inline-text :text="$t(`absence_reason.${item.unite}`)"/>
                    </template>
                    <template v-slot:[`item.mode`]="{ item }">
                        <w-inline-text :text="$t(`absence_reason.${item.mode}`)"/>
                    </template>
                    <template v-slot:[`item.includedInPay`]="{ item }">
                        <v-icon :color="item.includedInPay ? 'teal' : 'red'">mdi-check-circle</v-icon>
                    </template>
                    <template v-slot:[`item.color`]="{ item }">
                        <w-chip :color="item.color" text="    "/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>